import useScreenBreakpoint from "../../../hooks/useScreenBreakpoint";
import { Button } from "nectar-ui";
import PropTypes from "prop-types";
import * as React from "react";
import EmptyStateDashboardChart from "../../../svg/illustration/EmptyStateDashboardChart";
import { sendEventEmptyStateClick } from "../../../services/dashboardAnalyticEventService";
import { dashboardChartEmptyStatesTypes } from "../../../utils/constants/dashboard/analyticDashboardEvents";
import {
  EmptyStateWrapper,
  StyledHeading,
  StyledLinkButton,
  StyledText,
  TextWrapper,
} from "./style";
import { ChartIdentificationType } from "@customTypes/chart";

const DashboardDefaultChartEmptyState = ({
  title,
  subtitle,
  chartId,
  link,
  buttonText,
  buttonCallback,
}: {
  title: string | React.ReactNode;
  subtitle: string;
  chartId: ChartIdentificationType;
  link: string;
  buttonText?: string;
  buttonCallback?: () => void;
}) => {
  const { isMobileScreen } = useScreenBreakpoint();

  const sendMixPanelWhenClickToHelpCenter = () => {
    sendEventEmptyStateClick(dashboardChartEmptyStatesTypes.HELP_CENTER, chartId);
  };

  return (
    <EmptyStateWrapper>
      <EmptyStateDashboardChart mobile={isMobileScreen} />
      <TextWrapper mobile={isMobileScreen}>
        <StyledHeading size="xs" semiBold>
          {title}
        </StyledHeading>
        <StyledText size="md">{subtitle}</StyledText>
      </TextWrapper>
      {!!buttonText && !!buttonCallback && (
        <Button color="primary" onClick={buttonCallback}>
          {buttonText}
        </Button>
      )}
      <StyledLinkButton
        onClick={sendMixPanelWhenClickToHelpCenter}
        href={link}
        target="_blank"
        link
      >
        Saiba mais sobre este gráfico
      </StyledLinkButton>
    </EmptyStateWrapper>
  );
};

DashboardDefaultChartEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  chartId: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  buttonCallback: PropTypes.func,
};
DashboardDefaultChartEmptyState.defaultProps = {
  buttonText: undefined,
  buttonCallback: undefined,
};

export default DashboardDefaultChartEmptyState;
